export enum PlayerAction {
  NONE,

  TOGGLE_FOW,
  ADD_ELIXIR,
  ADD_XP,
  UNLOCK_ALL_ITEMS,
  COMPLETE_TAPESTRY,
  DELETE_LOCALSTORAGE,

  GO_HOME,
  CYCLE_OPTIC,
  EQUIP_TOOL,
  USE_GIZMO,
  MOVE_LEFT,
  MOVE_RIGHT,
  MOVE_UP,
  MOVE_DOWN,
  ROTATE_COUNTER_CLOCKWISE,
  ROTATE_CLOCKWISE,
  TOGGLE_WEAPON,
  UNEQUIP_TOOL,
  INTERACT,
  CLOSE_POPUP,
  USE_ELIXIR,
  USE_PORTAL_SCROLL,
  BIND_PIGMENT,
  VIEW_LOADOUT,
  CONFIRM_YES,
  CONFIRM_NO,
}

export enum AIAction {
  ATTACKING,
  DIED,
  MOVING,
  WAITING,
}

export enum Direction {
  UP,
  DOWN,
  LEFT,
  RIGHT,
}

export enum MapID {
  Playground,
  Portals,
  January,
  February,
  March,
  April,
  May,
  June,
  July,
  August,
  September,
  October,
  November,
  December,
}

export enum OneshotID {
  ESCAPE_ROPE,
}

export enum PaletteColor {
  YELLOW,
  RED,
  MAGENTA,
  BLUE,
  CYAN,
  GREEN,
  BLACK,
  WHITE,
  NONE,
}

export enum PlayerBody {
  HEAD,
  TORSO,
  FEET,
  LEFT_HAND,
  RIGHT_HAND,
}

export enum PopupID {
  TAPESTRY,
  ARCHIVE,
  BESTIARY,
  ARSENAL,
  WARDROBE,
  COMMON_FINDS,
  MYTHIC_FINDS,
  GIZMOS,
  VIEW_LOADOUT,
  NONE,
}

export enum EntryLocation {
  NONE,
  TOP_CENTER,
  RIGHT_CENTER,
  BOTTOM_CENTER,
  LEFT_CENTER,
}

export enum AttackType {
  NONE,
  DEVOUR,
  DRAIN_ESSENCE,
  DRAIN_PIGMENT,
  DRAIN_ESSENCE_AND_PIGMENT,
}

export enum EnemyType {
  NONE,
  RIFT_ESSENCE,
  RIFT_PIGMENT,
  RIFT_BOTH,
  SPECTRE_ESSENCE,
  SPECTRE_PIGMENT,
  SPECTRE_BOTH,
  REAVER_ESSENCE,
  REAVER_PIGMENT,
  REAVER_BOTH,
  BLADE_ESSENCE,
  BLADE_PIGMENT,
  BLADE_BOTH,
  VOID_ESSENCE,
  VOID_PIGMENT,
  VOID_BOTH,
  DEVOURER,
}

export enum ItemType {
  BOMB_PIGMENT,
  BOMB_ESSENCE,
  HINT_INFO,
  HINT_COLLECTIBLE,
  HINT_WARNING,
  ENTRANCE,
  ESSENCE,
  ESSENCE_OR_PIGMENT,
  KEY,
  // COLLECTIBLES
  COLLECTIBLE_COMMON,
  COLLECTIBLE_MYTHIC,
  // EQUIPMENT (HEADGEAR)
  EQUIPMENT_HEAD_NONE,
  EQUIPMENT_HEAD1,
  EQUIPMENT_HEAD2,
  EQUIPMENT_HEAD3,
  EQUIPMENT_HEAD4,
  EQUIPMENT_HEAD5,
  EQUIPMENT_HEAD6,
  EQUIPMENT_HEAD7,
  EQUIPMENT_HEAD8,
  // EQUIPMENT (TORSO)
  EQUIPMENT_TORSO_NONE,
  EQUIPMENT_TORSO1,
  EQUIPMENT_TORSO2,
  EQUIPMENT_TORSO3,
  EQUIPMENT_TORSO4,
  EQUIPMENT_TORSO5,
  EQUIPMENT_TORSO6,
  EQUIPMENT_TORSO7,
  EQUIPMENT_TORSO8,
  // EQUIPMENT (FEET)
  EQUIPMENT_FEET_NONE,
  EQUIPMENT_FEET1,
  EQUIPMENT_FEET2,
  EQUIPMENT_FEET3,
  EQUIPMENT_FEET4,
  EQUIPMENT_FEET5,
  EQUIPMENT_FEET6,
  EQUIPMENT_FEET7,
  EQUIPMENT_FEET8,
  // EQUIPMENT (GIZMOS)
  EQUIPMENT_GIZMO_NONE,
  EQUIPMENT_GIZMO1,
  EQUIPMENT_GIZMO2,
  EQUIPMENT_GIZMO3,
  EQUIPMENT_GIZMO4,
  EQUIPMENT_GIZMO5,
  EQUIPMENT_GIZMO6,
  // EQUIPMENT (WEAPONS)
  EQUIPMENT_WEAPON_NONE,
  EQUIPMENT_WEAPON1,
  EQUIPMENT_WEAPON2,
  EQUIPMENT_WEAPON3,
  EQUIPMENT_WEAPON4,
  EQUIPMENT_WEAPON5,
  EQUIPMENT_WEAPON6,
  EQUIPMENT_WEAPON7,
  // OPTICS
  OPTIC_YELLOW,
  OPTIC_NONE,
  OPTIC_RED,
  OPTIC_MAGENTA,
  OPTIC_BLUE,
  OPTIC_CYAN,
  OPTIC_GREEN,
  OPTIC_RANDOM,
  NONE,
  // PIGMENTS
  PIGMENT_YELLOW,
  PIGMENT_RED,
  PIGMENT_MAGENTA,
  PIGMENT_BLUE,
  PIGMENT_CYAN,
  PIGMENT_GREEN,
  PIGMENT_MATCH_OPTIC,
  PIGMENT_RANDOM,
  BINDER,

  ELIXIR,

  PORTAL,
  CASE_ACHIEVEMENTS,
  TAPESTRY,
}

export enum MapType {
  STATIC,
  DYNAMIC,
}

export function isPigment(type: ItemType): boolean {
  return (
    type == ItemType.PIGMENT_RED ||
    type == ItemType.PIGMENT_GREEN ||
    type == ItemType.PIGMENT_BLUE ||
    type == ItemType.PIGMENT_MAGENTA ||
    type == ItemType.PIGMENT_CYAN ||
    type == ItemType.PIGMENT_YELLOW
  )
}
